/**
 * Helper dùng chung cho Bộ lọc thời gian.
 * Mọi màn hình có bộ lọc thời gian phải import từ đây, không tự tính lại.
 */

// Số ngày mặc định của bộ lọc thời gian (tính cả ngày hôm nay)
export const DEFAULT_FILTER_RANGE_DAYS = 7

// Preset tùy chỉnh trên HeaderDashboard
export const CUSTOM_FILTER_DAY = 'custom'

export const MAX_FILTER_RANGE_DAYS = 31

/**
 * Lấy ngày cách hôm nay n ngày.
 * otp.type = 'start' => 00:00:00, otp.type = 'end' => 23:59
 */
export const getDateFromNow = (n, otp) => {
  let date = new Date()
  if (otp && otp?.type == 'start') date.setHours(0, 0, 0, 0)
  if (otp && otp?.type == 'end') date.setHours(23, 59, 0, 0)
  const res = date.setTime(date.getTime() + n * 24 * 60 * 60 * 1000)
  return new Date(res)
}

// 00:00:00 của ngày truyền vào
export const toStartOfDay = value => {
  const date = new Date(value)
  if (isNaN(date.getTime())) return value

  date.setHours(0, 0, 0, 0)
  return date
}

// 23:59 của ngày truyền vào
export const toEndOfDay = value => {
  const date = new Date(value)
  if (isNaN(date.getTime())) return value

  date.setHours(23, 59, 0, 0)
  return date
}

// Parse YYYY-MM-DD (và Date) theo local, tránh new Date('YYYY-MM-DD') = UTC
export const parseLocalDate = value => {
  if (!value) return null
  if (value instanceof Date) {
    if (isNaN(value.getTime())) return null
    return toStartOfDay(value)
  }
  const match = String(value)
    .trim()
    .match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (!match) return null
  const date = new Date(
    Number(match[1]),
    Number(match[2]) - 1,
    Number(match[3]),
  )
  date.setHours(0, 0, 0, 0)
  return isNaN(date.getTime()) ? null : date
}

export const formatLocalDate = value => {
  const date = parseLocalDate(value)
  if (!date) return ''
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export const orderDateRange = (a, b) => {
  const start = parseLocalDate(a)
  const end = parseLocalDate(b || a)
  if (!start) return [null, null]
  if (!end) return [start, start]
  return start <= end ? [start, end] : [end, start]
}

// Ngày bắt đầu mặc định: hôm nay - (days - 1), lúc 00:00
export const getDefaultFilterStartDate = (days = DEFAULT_FILTER_RANGE_DAYS) =>
  getDateFromNow(-(days - 1), {type: 'start'})

// Ngày kết thúc mặc định: hôm nay, lúc 23:59
export const getDefaultFilterEndDate = () => getDateFromNow(0, {type: 'end'})

// Khoảng mặc định: [hôm nay - 6 (00:00), hôm nay (23:59)]
export const getDefaultFilterDateRange = (days = DEFAULT_FILTER_RANGE_DAYS) => [
  getDefaultFilterStartDate(days),
  getDefaultFilterEndDate(),
]

// So sánh 2 giá trị có cùng 1 ngày dương lịch hay không (bỏ qua giờ)
export const isSameCalendarDay = (a, b) => {
  if (!a || !b) return false

  const dateA = new Date(a)
  const dateB = new Date(b)
  if (isNaN(dateA.getTime()) || isNaN(dateB.getTime())) return false

  return (
    dateA.getFullYear() === dateB.getFullYear() &&
    dateA.getMonth() === dateB.getMonth() &&
    dateA.getDate() === dateB.getDate()
  )
}

/**
 * Khi người dùng chọn lại NGÀY kết thúc => mặc định 23:59 của ngày đó.
 * Nếu chỉ chỉnh GIỜ (vẫn cùng 1 ngày kết thúc) => giữ nguyên giờ user chọn.
 */
export const normalizeDateRangeEndTime = (nextRange, prevRange) => {
  if (!Array.isArray(nextRange) || !nextRange[1]) return nextRange

  const nextEnd = new Date(nextRange[1])
  if (isNaN(nextEnd.getTime())) return nextRange

  const prevEnd = Array.isArray(prevRange) ? prevRange[1] : null
  const endIsMidnight = nextEnd.getHours() === 0 && nextEnd.getMinutes() === 0
  // Cùng ngày nhưng rsuite reset 00:00 sau click lịch → vẫn lấy 23:59
  if (isSameCalendarDay(prevEnd, nextEnd) && !endIsMidnight) return nextRange

  return [nextRange[0], toEndOfDay(nextEnd)]
}
